var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalDelete',{attrs:{"package-item-id":_vm.packageItemId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }